/**
 * Converts a contract object to form data format
 * @param {Object} contract - The contract object
 * @returns {Object} Form data object with default values
 */
const contractToFormData = (contract) => {
    if (!contract) {
        return {
            name: '',
            allowLateFees: false,
            lateFeeMin: 0,
            lateFeeMax: 0,
            lateFeeDays: 0,
            lateFeePercentage: 0,
            lateFeeCalculatedBy: 'Payment',
            allowNSFCharges: false,
            nSFCharges: 0,
            lateFeeAllocationLogic: '',
        };
    }

    return {
        name: contract.name || '',
        allowLateFees: contract.allowLateFees || false,
        lateFeeMin: contract.lateFeeMin || 0,
        lateFeeMax: contract.lateFeeMax || 0,
        lateFeeDays: contract.lateFeeDays || 0,
        lateFeePercentage: contract.lateFeePercentage || 0,
        lateFeeCalculatedBy: contract.lateFeeCalculatedBy || 'Payment',
        allowNSFCharges: contract.allowNSFCharges || false,
        nSFCharges: contract.nSFCharges || 0,
        lateFeeAllocationLogic: contract.lateFeeAllocationLogic || '',
    };
};

export default contractToFormData;
